import React, { useState } from 'react';
import ReactTooltip from 'react-tooltip';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import { Spinner } from 'react-bootstrap';
import { usePostBulletinMessageMutation } from '../../services/api';
import { useBulletin } from '../../context/bulletin';

interface FlagModalProps {
  show: boolean;
  type: 'system' | 'category' | 'entry' | 'map';
  id: string;
  onCancel: () => void;
  onSuccess: () => void;
}

function FlagModal({ show, type, id, onCancel, onSuccess }: FlagModalProps) {
  const [value, setValue] = useState('');

  const { bulletinType, bulletinDate } = useBulletin();

  const { mutateAsync, isLoading, isError } = usePostBulletinMessageMutation(
    bulletinType,
    bulletinDate,
    type,
    id,
    false,
  );

  async function onSubmit() {
    try {
      await mutateAsync(value);
      onSuccess();
    } catch {
      // NO OP
    }
  }

  return (
    <Modal
      show={show}
      onHide={!isLoading ? onCancel : undefined}
      size="lg"
      centered
    >
      <Modal.Header>
        <h2>
          Explaination of the anomaly
          <span
            data-tip="Comment the irregularity spotted on the content"
            data-for="help"
            className="icon-info-circle"
          />
        </h2>
        <ReactTooltip
          id="help"
          place="top"
          type="dark"
          effect="solid"
          delayHide={1500}
          className="tooltip"
          multiline
        />
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group>
            <Form.Label>
              Comment about the irregularity of the content
            </Form.Label>
            <Form.Control
              as="textarea"
              style={{ height: '100px' }}
              value={value}
              onChange={e => setValue(e.target.value)}
              data-cy="flag-modal-input"
              disabled={isLoading}
              isInvalid={isError}
              required
            />
            {isError && (
              <Form.Text className="text-danger">
                An error occured, please try again.
              </Form.Text>
            )}
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="outline-primary"
          onClick={onCancel}
          disabled={isLoading}
        >
          Cancel
        </Button>
        <Button
          variant="danger"
          data-cy="flag-modal-submit-button"
          type="submit"
          onClick={onSubmit}
          disabled={isLoading || !value || !value.trim()}
        >
          {isLoading && (
            <span style={{ paddingRight: 6 }}>
              <Spinner animation="border" role="status" size="sm">
                <span className="visually-hidden">Loading...</span>
              </Spinner>
            </span>
          )}
          Flag
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default FlagModal;
